import api from "utils/api";
import { formatUserDisplayName } from "utils/formatUserDisplayName";
import type { MarkerNoteResponse, SaveElementNote } from "./types";

export const saveElementNote: SaveElementNote = async ({
  elementId,
  content,
  existingNote,
  viewer,
}) => {
  if (content === "") {
    await api.deleteQuantitySurveyorElementMarkerNote(elementId);
    return null;
  }

  const saved: MarkerNoteResponse =
    await api.setQuantitySurveyorElementMarkerNote(elementId, { content });
  return {
    content: saved.content,
    // An existing note keeps its author, hidden or not; a new one is the viewer's own.
    createdBy:
      existingNote === null
        ? formatUserDisplayName({
            firstName: viewer?.firstName ?? null,
            lastName: viewer?.lastName ?? null,
            email: viewer?.email ?? null,
          })
        : existingNote.createdBy,
    createdAt: saved.createdAt,
    updatedAt: saved.updatedAt,
  };
};
